import type { ClipVariant } from '../../lib/types.ts';

/**
 * Человекочитаемое имя варианта. Своего названия у варианта в БД нет —
 * его отличают геометрия наложения и доля кадра, поэтому заголовок собираем
 * из них (в прототипе на этом месте «Вертикаль · логотип снизу»).
 */
export function variantTitle(v: Pick<ClipVariant, 'position' | 'sizePct'>): string {
  return `${v.position} ${v.sizePct}%`;
}
